import { render } from "./ZfAvatar.vue?vue&type=template&id=8ed187a6&scoped=true&ts=true"
import script from "./ZfAvatar.vue?vue&type=script&lang=ts"
export * from "./ZfAvatar.vue?vue&type=script&lang=ts"

import "./ZfAvatar.vue?vue&type=style&index=0&id=8ed187a6&lang=less&scoped=true"
import "./ZfAvatar.vue?vue&type=style&index=1&id=8ed187a6&lang=less"

import exportComponent from "/var/jenkins_home/workspace/正式_ls/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ed187a6"]])

export default __exports__